import { jsx as a } from "react/jsx-runtime";
import { useZoomModal as f } from "../../../../components/ZoomModal/index.js";
import { Image as n } from "./styles.js";
import { removeQueryParams as p } from "../../../../services/url/index.js";
function l({ onClick: o, src: m, ...r }) {
  const e = f();
  return /* @__PURE__ */ a(n, { ...r, src: m, onClick: (t) => {
    o == null || o(t), e({ ...r, src: p(m) });
  } });
}
export {
  l as CommentImage
};
